import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { eventRequestTypes } from '@clatter/platform';
import { useNgTrackEvent } from '../../hooks/useNgTrackEvent';

const PAGEVISIT_BLACKLIST = ['/sso/callback'];

const TrackPageviewEvent = () => {
  const location = useLocation();
  const track = useNgTrackEvent();

  useEffect(() => {
    if (PAGEVISIT_BLACKLIST.includes(location.pathname)) {
      return;
    }

    track(eventRequestTypes.pagevisit);
  }, [location.key, track]);

  return null;
};

export default TrackPageviewEvent;
